module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "part01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong', [_vm._v("PART ONE"), _c('br'), _vm._v("The Day You See Me Fall Is Not the Day I Die")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/symbol.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('strong', [_vm._v("One black peasant woman fell upon her Knees with her arms outstretched like a crucifix and cried, “They say that the white man is coming to rule Haiti again. The black man is so cruel to his own, "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("let the white man come!")]), _vm._v("”")])])]), _c('p', {
    staticClass: "attribution1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong', [_vm._v("—Zora Neale Hurston (1938).")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 93
// module chunks = 0